import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '../../../environments/environment'
import { JSONRpc } from '../service-jsonrpc'


//import moment = require('moment')
import * as moment from 'moment'

@Injectable({
	providedIn: 'root',
})
export class ParameterService {
	cacheListStatusDossier: any[]
	cacheListStateDossier: any[]
	cacheListZoneDossier: any[]
	cacheListEtatInstru: any[]
	cacheListTypeInstru: any[]



	constructor(private http: HttpClient) { }

	getDemandesWithForms(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:demande',
			params: {
				options: {
					forms: true,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getPages(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:page',
			params: {
				options: {
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getContactTypes(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:contact',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getStateDossierList(): Observable<any> {
		if (
			!this.cacheListStateDossier ||
			this.cacheListStateDossier.length == 0
		) {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.parametre:state',
				params: {},
			})
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListStateDossier = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListStateDossier,
			})
	}
	getZoneDossierList(): Observable<any> {
		if (
			!this.cacheListZoneDossier ||
			this.cacheListZoneDossier.length === 0
		) {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.parametre:zones',
				params: {},
			})
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListZoneDossier = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListZoneDossier,
			})
	}
	
	getAllZones(): Observable<any> {

      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.parametre:zones2",
        params: {
          
          options: {
            type:true
          }
        }

    });

   
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }
	
	getEtatInstruction(): Observable<any> {
		if (!this.cacheListEtatInstru || this.cacheListEtatInstru.length == 0) {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.parametre:instructionstatut',
				params: {},
			})
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListEtatInstru = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListEtatInstru,
			})
	}
	getTypeInstruction(options: any = []): Observable<any> {
		if (!this.cacheListTypeInstru || this.cacheListTypeInstru.length == 0) {
			
			let _params={
				jsonrpc: '2.0',
				method: 'webservice.parametre:instruction',
				params: {
					options: options
				}	
			};
			
			let rpcMethod = new JSONRpc(_params)
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListTypeInstru = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListTypeInstru,
			})
	}
	
	getZoneTypes(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.parametre:zonestype",
      params: {
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);

  }
  
  application(): Observable<any> {
     let rpcMethod = new JSONRpc({
       jsonrpc: "2.0",
       method: "webservice.parametre:application",
       params: {
        
       }
     });
     return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
   }
   
   
   getTiersTypeList(code?: string): Observable<any> {
     		let rpcMethod = new JSONRpc({
     		     jsonrpc: "2.0",
     		     method: "webservice.parametre:tierstypes",
     		     params: {
     		      
     		     }
     		   });
     		   
     		   
     		  if (code!=undefined && code ) rpcMethod.params.code = code
     		   
     		return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
   }
   openid(): Observable<any> {
       let rpcMethod = new JSONRpc({
         jsonrpc: "2.0",
         method: "webservice.parametre:openid",
         params: {
          
         }
       });
       return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
   }
}
